import React, {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import {useAuthStore} from '../../store/authStore';

function Register() {
    const register = useAuthStore((state) => state.register);
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [displayName, setDisplayName] = useState('');
    const [error, setError] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError(null);

        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        setSubmitting(true);
        try {
            await register({email, password, displayName});
            navigate('/account');
        } catch (err) {
            setError(err.message);
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="w-full flex justify-center bg-gradient-to-r from-blue-300 via-white to-green-100 rounded-lg py-10">
        <div className="container py-5 rounded-lg bg-gradient-to-br from-gray-50 via-orange-50 to-orange-50 dark:from-gray-950 dark:to-gray-900" style={{maxWidth: '420px'}}>
            <h1 className="text-2xl font-semibold leading-tight text-blue-800 mb-4">Create an account</h1>

            {error && <div className="text-red-600 mb-3">{error}</div>}

            <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="registerDisplayName">
                    <Form.Label>Display name</Form.Label>
                    <Form.Control required value={displayName}
                                  onChange={(e) => setDisplayName(e.target.value)}
                                  placeholder="How you'll appear on comments"
                                  className="rounded-lg bg-green-50 border border-blue-300"/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="registerEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" required value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  placeholder="Enter email"
                                  className="rounded-lg bg-green-50 border border-blue-300"/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="registerPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" required minLength={8} value={password}
                                  onChange={(e) => setPassword(e.target.value)}
                                  placeholder="At least 8 characters"
                                  className="rounded-lg bg-green-50 border border-blue-300"/>
                </Form.Group>

                <Form.Group className="mb-3" controlId="registerConfirmPassword">
                    <Form.Label>Confirm password</Form.Label>
                    <Form.Control type="password" required value={confirmPassword}
                                  onChange={(e) => setConfirmPassword(e.target.value)}
                                  placeholder="Re-enter password"
                                  className="rounded-lg bg-green-50 border border-blue-300"/>
                </Form.Group>

                <Button variant="primary" type="submit" disabled={submitting}>
                    {submitting ? 'Creating account...' : 'Register'}
                </Button>
            </Form>

            <p className="mt-3 text-sm text-gray-600">
                Already have an account? <a href="/login" className="text-blue-600">Log in</a>
            </p>
        </div>
        </div>
    );
}

export default Register;
